document.addEventListener('DOMContentLoaded', function() {
    // Select the elements
    var variantPicker = document.querySelector('.variant-picker__option[data-option="color"] [data-option-selector]');
    var productGalleryContent = document.querySelector('.product-gallery__image-list .custom-thumb--wrapper ');

    // Check if both elements exist
    if (variantPicker && productGalleryContent && productGalleryContent.parentNode) {
        // Move the variant picker below the span
        productGalleryContent.append(variantPicker);
    }
});


(() => {
  const MOBILE_MEDIA = window.matchMedia('(max-width: 749px)'); // adjust to your theme

  function syncOne(container) {
    const thumbs   = container.querySelector('.custom-thumb--wrapper');
    const contents = container.querySelector('.contents');
    if (!thumbs || !contents) return;

    // If stacked on mobile, clear the max-height
    if (MOBILE_MEDIA.matches) {
      thumbs.style.maxHeight = '';
      return;
    }

    // Measure current contents height and apply to thumbs
    const h = contents.getBoundingClientRect().height;
    if (h > 0) thumbs.style.maxHeight = Math.round(h) + 'px';
  }

  function syncAll() {
    document.querySelectorAll('.product-gallery__image-list').forEach(syncOne);
  }

  // Debounce for resize
  let rAF = null;
  function onResize() {
    if (rAF) cancelAnimationFrame(rAF);
    rAF = requestAnimationFrame(syncAll);
  }

  // Observe each gallery's contents for dynamic height changes (images, slides, etc.)
  const observers = [];
  function attachObservers() {
    document.querySelectorAll('.product-gallery__image-list').forEach(container => {
      const contents = container.querySelector('.contents');
      if (!contents) return;

      // ResizeObserver reacts to internal layout/size changes
      const ro = new ResizeObserver(() => syncOne(container));
      ro.observe(contents);
      observers.push(ro);

      // Also re-sync when images finish loading (in case of late loads)
      contents.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', () => syncOne(container), { once: true });
      });
    });
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      attachObservers();
      syncAll();
    });
  } else {
    attachObservers();
    syncAll();
  }

  // Re-sync on window resize and when breakpoint flips
  window.addEventListener('resize', onResize);
  MOBILE_MEDIA.addEventListener?.('change', syncAll);
})();




// prev next button
document.addEventListener('DOMContentLoaded', function () {
    let currentIndex = 0;
    const mediaItems = document.querySelectorAll('.product-gallery__media');
    const carousel = document.querySelector('.product-gallery__carousel');

    if (!carousel || mediaItems.length === 0) {
      console.error('Carousel or media items not found.');
      return;
    }

    const totalItems = mediaItems.length;

    function updateCarousel(index) {
      mediaItems.forEach((item, i) => {
        item.setAttribute('aria-current', i === index ? 'true' : 'false');
        item.classList.toggle('is-initial', i === index);
      });
      // Scroll to the selected item
      carousel.scrollTo({
        left: mediaItems[index].offsetLeft,
        behavior: 'smooth'
      });
    }

    window.previousMedia = function () {
      currentIndex = (currentIndex > 0) ? currentIndex - 1 : totalItems - 1;
      updateCarousel(currentIndex);
    };

    window.nextMedia = function () {
      currentIndex = (currentIndex < totalItems - 1) ? currentIndex + 1 : 0;
      updateCarousel(currentIndex);
    };
  });

document.addEventListener('DOMContentLoaded', function() {
    function updateCountdown() {
        const products = document.querySelectorAll('.product-card, .shopify-section--main-product');

        products.forEach(product => {
            const badge = product.querySelector('.launch-date-badge');
            const buyButtonContainers = product.querySelectorAll('.buy-buttons'); // Use querySelectorAll for all buy button containers

            if (badge) {
                const launchTime = new Date(badge.getAttribute('data-time')).getTime();
                const now = new Date().getTime();
                const distance = launchTime - now;

                if (distance > 0) {
                    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    if (days >= 1) {
                        badge.innerText = `Comes in ${days} day${days > 1 ? 's' : ''}`;
                    } else {
                        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                        badge.innerText = `Comes in ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                    }

                    buyButtonContainers.forEach(buyButtonContainer => {
                        const buyButton = buyButtonContainer.querySelector('button');
                        if (buyButton) {
                            buyButton.innerText = 'Coming Soon';
                            buyButton.disabled = true;
                        }
                    });
                } else {
                    const daysPast = Math.floor(-distance / (1000 * 60 * 60 * 24));
                    if (daysPast <= 1) {
                        badge.innerText = "Just Launched";
                    } else {
                        badge.remove();
                    }

                    buyButtonContainers.forEach(buyButtonContainer => {
                        const buyButton = buyButtonContainer.querySelector('button');
                        if (buyButton) {
                            buyButton.innerText = 'ADD TO CART';
                            buyButton.disabled = false;
                        }
                    });
                }
            }
        });
    }

    // Initial call to set the countdown and button state
    updateCountdown();

    // Update countdown every second
    setInterval(updateCountdown, 1000);
});

document.addEventListener('variant:change', function(event) {
    const variant = event.detail.variant;
    const buyButtonContainers = document.querySelectorAll('.buy-buttons'); // Use querySelectorAll for all buy button containers
    
    if (variant.available) {
        buyButtonContainers.forEach(buyButtonContainer => {
            const button = buyButtonContainer.querySelector(".button");
            if (button) {
                button.innerText = buyButtonContainer.dataset.preorder;
            }
        });
    }
});

$(document).ready(function() {
    // Toggle sharing on .share click
    $('.share').click(function() {
        $('.sharing').toggleClass('is-visible');
    });

    var countdownElement = $('#flash-sale-countdown');

    if (countdownElement.length > 0) {
        var parseDateAsUTC = function(dateStr) {
            // Convert from GMT+7 to UTC
            var date = new Date(dateStr + 'Z');
            return new Date(date.getTime() - (7 * 3600000)); // Adjust from GMT+7 to UTC
        };

        var parseFlashSaleData = function(data) {
            var periods = data.split("*").filter(function(period) {
                return period.trim() !== '';
            }).map(function(period) {
                var parts = period.trim().split(" ");
                return {
                    startTime: parseDateAsUTC(parts[0] + ' ' + parts[1]),
                    endTime: parseDateAsUTC(parts[2] + ' ' + parts[3]),
                    recurrence: parts[4],
                    recurrenceEndDate: parseDateAsUTC(parts[5] + ' ' + parts[6])
                };
            });
            return periods;
        };

        var isSaleActive = function(period, now) {
            var start = new Date(period.startTime.getTime());
            var end = new Date(period.endTime.getTime());
            var recurrence = period.recurrence;

            switch (recurrence) {
                case 'daily':
                    start.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                    end.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                    break;
                case 'weekly':
                    var dayDiff = now.getDay() - start.getDay();
                    start = new Date(start.getTime() + dayDiff * 24 * 60 * 60 * 1000);
                    end = new Date(end.getTime() + dayDiff * 24 * 60 * 60 * 1000);
                    break;
                case 'monthly':
                    start.setMonth(now.getMonth());
                    end.setMonth(now.getMonth());
                    break;
                case 'one-time':
                    // No change needed for one-time events
                    break;
            }

         // Check against recurrence end date
            if (period.recurrence !== 'one-time' && now > period.recurrenceEndDate) {
                // Check if it's more than a day past the recurrence end date
                var recurrenceEndPlusOneDay = new Date(period.recurrenceEndDate.getTime() + ( 5 * 60 * 1000));
                if (now > recurrenceEndPlusOneDay) {
                    return false; // Sale period has ended
                }
            }


          
            return now >= start && now <= end;
        };

        var updateCountdown = function() {
    var nowUTC = new Date(new Date().toUTCString()); // Current UTC time
    var salePeriods = parseFlashSaleData(countdownElement.data('flash-sale'));
    var saleActive = false;
    var nextSaleStarts = null;

    for (var i = 0; i < salePeriods.length; i++) {
        var period = salePeriods[i];
        var start = new Date(period.startTime.getTime());
        var end = new Date(period.endTime.getTime());


         // Skip period if current time is past the recurrence end date
        if (period.recurrence !== 'one-time' && nowUTC > period.recurrenceEndDate) {
            // Check if it's more than a day past the recurrence end date
            var recurrenceEndPlusOneDay = new Date(period.recurrenceEndDate.getTime() + ( 5 * 60 * 1000));
            if (nowUTC > recurrenceEndPlusOneDay) {
                continue;
            }
        }

      
        // Adjust start and end times based on recurrence
        switch (period.recurrence) {
            case 'daily':
                start.setFullYear(nowUTC.getFullYear(), nowUTC.getMonth(), nowUTC.getDate());
                end.setFullYear(nowUTC.getFullYear(), nowUTC.getMonth(), nowUTC.getDate());
                break;
            case 'weekly':
                // Find the next occurrence of the sale
                while (start < nowUTC) {
                    start.setDate(start.getDate() + 7);
                    end.setDate(end.getDate() + 7);
                }
                break;
            case 'monthly':
                // Find the next occurrence of the sale
                while (start < nowUTC) {
                    start.setMonth(start.getMonth() + 1);
                    end.setMonth(end.getMonth() + 1);
                }
                break;
            // No adjustment needed for one-time events
        }

        // Check if the sale is currently active
        if (nowUTC >= start && nowUTC <= end) {
            var distanceToEnd = end - nowUTC;
            countdownElement.show();
            countdownElement.html("Flash Sale ends in: " + formatCountdown(distanceToEnd));
            saleActive = true;
            break;
        } else if (start > nowUTC) {
            if (!nextSaleStarts || start < nextSaleStarts) {
                nextSaleStarts = start;
            }
        }
    }

    // Display countdown to next sale if not currently active
    if (!saleActive && nextSaleStarts) {
        var distanceToStart = nextSaleStarts - nowUTC;
        if (distanceToStart <= 1 * 60 * 60 * 1000) { // Upcoming sale is within 1 hours
            countdownElement.show();
            countdownElement.html("Flash Sale starts in: " + formatCountdown(distanceToStart));
        } else {
           // countdownElement.html("Next Flash Sale Soon!");
        }
    } else if (!saleActive && !nextSaleStarts) {
    // If no upcoming sale and not currently active, hide the countdown
        clearInterval(interval);
        countdownElement.hide();
        var section = countdownElement.closest('.shopify-section');
if (section.length) {
    section.style.display = 'none';
}
      console.log('hide');
    } else if (!saleActive) {
        clearInterval(interval);
        countdownElement.html("Flash Sale Ended");
    }
};

        var formatCountdown = function(distance) {
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            return days + "d " + hours + "h " + minutes + "m " + seconds + "s";
        };

        var interval = setInterval(updateCountdown, 1000);
        updateCountdown();

      var flashSaleCountdown = document.getElementById('flash-sale-countdown');
var shopifySection = flashSaleCountdown.closest('.shopify-section');

if (flashSaleCountdown && flashSaleCountdown.innerHTML.trim() === '') {
    if (shopifySection.length) {
        shopifySection.style.display = 'none';
    }
}
    }
});




  document.addEventListener("DOMContentLoaded", function () {
    const carousel = document.querySelector('.complementary-products__product-list');
    const btnNext = document.querySelector('#complementary-next');
    const btnPrev = document.querySelector('#complementary-prev');

    if (!carousel || !btnNext || !btnPrev) return;

    const getCardWidth = () => {
      const card = carousel.querySelector('.horizontal-product-card');
      return card ? card.offsetWidth : 0;
    };

    btnNext.addEventListener('click', () => {
      const scrollAmount = getCardWidth();
      if (scrollAmount > 0) {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        console.log('Scroll Right:', scrollAmount);
      }
    });

    btnPrev.addEventListener('click', () => {
      const scrollAmount = getCardWidth();
      if (scrollAmount > 0) {
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        console.log('Scroll Left:', scrollAmount);
      }
    });
  });




